import { render, staticRenderFns } from "./ApprRuleSet.vue?vue&type=template&id=10ab9634&scoped=true"
import script from "./ApprRuleSet.vue?vue&type=script&lang=js"
export * from "./ApprRuleSet.vue?vue&type=script&lang=js"
import style0 from "./ApprRuleSet.vue?vue&type=style&index=0&id=10ab9634&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ab9634",
  null
  
)

export default component.exports